import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'


@Component({
    selector: 'app-asda-delete-popup',
    templateUrl: './asda-delete-popup.component.html',
    styleUrls: ['./asda-delete-popup.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
    ],
})
export class AsdaDeletePopupComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {

    }

}
